<template>
    <div class="pp">
        <div class="pp-icon">
            <!--<span class="fa-stack fa-xs" style="margin-left:-10px;">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i :class="'fa fa-' + icon + ' fa-stack-1x fa-inverse'"></i>
            </span>-->
            <i :class="'fa fa-' + icon"></i>
        </div>
        <strong>
            {{ title }}
        </strong>
        <br>
        <slot name="description"></slot>
    </div>
</template>
<script>
    export default {
        props: ['title', 'description', 'icon']
    }
</script>



// WEBPACK FOOTER //
// pro-point.vue?6fa6da5c